import React from 'react';
import { faUser, faSignOutAlt, faUsers, faCog } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useLocation, useNavigate } from 'react-router-dom';
import { useAuth } from '../hooks/useAuth';
import { ROLE_DISPLAY_NAMES } from '../services/invitationService';
import Button from './Button';

interface MobileProfileMenuProps {
  isOpen: boolean;
  onLogout: () => void;
}

export default function MobileProfileMenu({
  isOpen,
  onLogout
}: MobileProfileMenuProps): React.ReactElement | null {
  const { user, currentOrganization } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();

  // Check if we're in admin context
  const isAdminContext = location.pathname.startsWith('/admin');
  const isOwner = currentOrganization?.role === 'owner';

  if (!isOpen) return null;

  function handleUsersNavigation() {
    navigate('/users');
  }

  function handleOrganizationSettings() {
    navigate('/org');
  }

  return (
    <div className="border-t border-gray-200 bg-white">
      <div className="px-4 py-3">
        <div className="flex items-center space-x-3">
          <div className="flex items-center justify-center w-10 h-10 bg-blue-600 rounded-full">
            <FontAwesomeIcon icon={faUser} className="w-5 h-5 text-white" />
          </div>
          <div>
            <p className="text-base font-medium text-gray-900">{user?.email || 'Usuário'}</p>
            <p className="text-sm text-gray-500 capitalize">
              {isAdminContext
                ? ROLE_DISPLAY_NAMES['saasadmin']
                : ROLE_DISPLAY_NAMES[
                    currentOrganization?.role as keyof typeof ROLE_DISPLAY_NAMES
                  ] || 'User'}
            </p>
          </div>
        </div>
        <div className="mt-3 flex flex-col gap-2">
          {isOwner && (
            <>
              <Button onClick={handleOrganizationSettings} variant="outline" fullWidth leftIcon={faCog}>
                Configurações da Organização
              </Button>
              <Button onClick={handleUsersNavigation} variant="outline" fullWidth leftIcon={faUsers}>
                Usuários
              </Button>
            </>
          )}
          <Button onClick={onLogout} variant="danger" fullWidth leftIcon={faSignOutAlt}>
            Sair do Sistema
          </Button>
        </div>
      </div>
    </div>
  );
}
